import type { EncryptedField, EncryptedPayload } from './types'

export const isEncryptedPayload = (value: unknown): value is EncryptedPayload => {
  if (typeof value !== 'object' || value === null) return false

  const record = value as Record<string, unknown>

  return (
    record['encrypted'] === true &&
    record['algorithm'] === 'AES-256-GCM' &&
    typeof record['keyVersion'] === 'number' &&
    Number.isInteger(record['keyVersion']) &&
    record['keyVersion'] >= 1 &&
    typeof record['ciphertext'] === 'string' &&
    record['ciphertext'].length > 0 &&
    typeof record['iv'] === 'string' &&
    record['iv'].length > 0
  )
}

export const hasEncryptedField = (payload: Record<string, unknown>, field: string): boolean => {
  return isEncryptedPayload(payload[field])
}

const BASE64_PATTERN = /^[A-Za-z0-9+/]+={0,2}$/

export const isEncryptedField = (value: unknown): value is EncryptedField => {
  if (typeof value !== 'object' || value === null) return false

  const obj = value as Record<string, unknown>

  return (
    typeof obj['ciphertext'] === 'string' &&
    obj['ciphertext'].length > 0 &&
    BASE64_PATTERN.test(obj['ciphertext']) &&
    typeof obj['iv'] === 'string' &&
    obj['iv'].length > 0 &&
    BASE64_PATTERN.test(obj['iv'])
  )
}
